import React from 'react';

import { Carousel as CarouselCore } from 'react-responsive-carousel';

import { TCarouselProps } from '@/types';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

/**
 * @description UI Component for Carousel.
 *
 * @author Swapnil Misal <@swapnil.misal>
 *
 * @reference https://www.npmjs.com/package/react-responsive-carousel
 *
 * @returns {React.ReactElement}
 */
const Carousel = ({
	children,
	...props
}: TCarouselProps): React.ReactElement => {
	return <CarouselCore {...props}>{children}</CarouselCore>;
};

export default Carousel;
